import React from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import AdminBreadcrumb from '../../../../components/Administration/General/Admin-breadcrumb';

const AquaaAdminOnboardLanding = () => {
    const history = useHistory();
    const AquaaAdminTiles = [
      { id: 1,
        title: 'Accounts',
        path:'/aquaaadminaccounts'
      },
      {
        id: 2,
        title: 'ContactType Form',
        path:'/aquaaadmincontacttypeform'
      },
      {
        id: 3,
        title: 'Questions',
        path:'/aquaaadminquestions'
      },
      {
        id: 4,
        title: 'Mapping',
        path:'/aquaaadminmapping'
      },
        {
            id: 5,
            path: "/accountevaluatormapping",
            title:'Account Evaluator Mapping',
        }
     
    ]
  return (
    <div>
    <AdminBreadcrumb value1={() => history.push('/applications')} label1='Applications' isActive2={true} value2={() => history.push('/aquaaapplications')} label2='AQuAA' isActive3={false}
         label3='AQuAA Admin'/>
         <section style={{ marginTop: 20 }}>
        <ul style={{ display: 'flex', flexWrap: 'wrap' }}>
          {
            (AquaaAdminTiles).map((data, index) => (<li className='grid_item_users' onClick={()=>history.push(data.path)}>
              <div className='image_text_users'>
                <div className='username_userflow' style={{textAlign:'center'}}>{data.title}</div>
              </div>
            </li>
            ))}
        </ul>
      </section>

    </div>
  )
}

export default AquaaAdminOnboardLanding